export default __webpack_public_path__ + "static/media/icon_flag_red.dd60bea2.svg";